import { useEffect, useState } from 'react'

// Detects when the bottom of `container` is within `threshold` px of the
// viewport bottom. Uses IntersectionObserver with a zero-height sentinel
// appended to the container so we never read layout (getBoundingClientRect)
// on every scroll frame.
const useScrollPositionAtBottom = (container, threshold = 100) => {
  const [isAtBottom, setScrollAtBottom] = useState(false)

  useEffect(() => {
    const containerEl = container && container.current
    if (!containerEl) return

    if (typeof IntersectionObserver === 'undefined') {
      // Older browsers / SSR: trigger an initial load so the grid still works.
      setScrollAtBottom(true)
      return
    }

    const sentinel = document.createElement('div')
    sentinel.setAttribute('aria-hidden', 'true')
    sentinel.style.cssText = 'display:block;width:100%;height:0;margin:0;padding:0;pointer-events:none;'
    containerEl.appendChild(sentinel)

    const observer = new IntersectionObserver(
      entries => {
        const entry = entries[0]
        if (entry) setScrollAtBottom(entry.isIntersecting)
      },
      { rootMargin: `0px 0px ${threshold}px 0px` }
    )
    observer.observe(sentinel)

    return () => {
      observer.disconnect()
      if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel)
    }
  }, [container, threshold])

  return isAtBottom
}
export default useScrollPositionAtBottom
